import { rcConstants } from '../constants'
import { rcService } from '../../services'
import { success, failure } from './helper'

function checkUserToken() {
  return async dispatch => {
    try {
      const token = rcService.getUserToken()
      if (!token) throw new Error('The token is absent')
      const isTokenValid = await rcService.verifyUserToken(token)
      if (!isTokenValid) throw new Error('The token not valid')
      return dispatch(success(rcConstants.SAVE_AUTH_USER_SUCCESS, { token }))
    } catch (err) {
      return dispatch(failure(rcConstants.SAVE_AUTH_USER_FAILURE))
    }
  }
}

function removeUserAuth() {
  rcService.removeUserToken()
  return dispatch => dispatch(success(rcConstants.REMOVE_AUTH_USER))
}

export default {
  checkUserToken,
  removeUserAuth,
}
